<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20Z"
      fill="#EB5554"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5358 6.46428C13.9264 6.8548 13.9264 7.48797 13.5358 7.87849L7.87898 13.5353C7.48846 13.9259 6.85529 13.9259 6.46477 13.5353C6.07424 13.1448 6.07424 12.5117 6.46477 12.1211L12.1216 6.46428C12.5121 6.07376 13.1453 6.07376 13.5358 6.46428Z"
      fill="#F7F9FD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.46477 6.46428C6.85529 6.07376 7.48846 6.07376 7.87898 6.46428L13.5358 12.1211C13.9264 12.5117 13.9264 13.1448 13.5358 13.5353C13.1453 13.9259 12.5121 13.9259 12.1216 13.5353L6.46477 7.87849C6.07424 7.48797 6.07424 6.8548 6.46477 6.46428Z"
      fill="#F7F9FD"
    />
  </svg>
</template>